import type { Schema } from '@cli-types/core-engine/schema.js'
import { normalizeEntitySchema } from './normalize-entity-schema.js'
import { normalizeLoadedSchema } from './normalize-loaded-schema.js'

export function normalizeLoadedEntitySchema(parsed: unknown): Schema {
  return normalizeEntitySchema(normalizeLoadedSchema(parsed))
}
